<div class="body">
  <div *ngIf="vademecum">
    <!-- <div class="page">

      <p>
        last name: {{vademecum.medicalDoc.lastName}}
      </p>
      <p>
        first name: {{vademecum.medicalDoc.firstName}}
      </p>
      <p>
        street: {{vademecum.medicalDoc.streetName}}
      </p>
      <p>
        number: {{vademecum.medicalDoc.streetNumber}}
      </p>
      <p>
        city: {{vademecum.medicalDoc.city}}
      </p>
      <p>
        post code: {{vademecum.medicalDoc.postCode}}
      </p>
      <p>
        birth date: {{vademecum.medicalDoc.birthDate}}
      </p>
      <p>
        phone number: {{vademecum.medicalDoc.phoneNumber}}
      </p>
      <p>
        start date: {{vademecum.medicalDoc.startDate}}
      </p>
      <p>
        {{vademecum.medicalDoc.endDate}}
      </p>
      <p>
        {{vademecum.medicalDoc.targetLanguage.name}}
      </p>
      <p>
        {{vademecum.medicalDoc.doctorName}}
      </p>
      <p>
        {{vademecum.medicalDoc.doctorPhoneNumber}}
      </p>
      <p>
        {{vademecum.medicalDoc.experiencedDiseases}}
      </p>
      <p>
        {{vademecum.medicalDoc.hasDiabetes}}
      </p>
      <p>
        {{vademecum.medicalDoc.hasAsthma}}
      </p>
      <p>
        {{vademecum.medicalDoc.hasHeartTrouble}}
      </p>
      <p>
        {{vademecum.medicalDoc.hasEpilepsy}}
      </p>
      <p>
        {{vademecum.medicalDoc.hasRheumatism}}
      </p>
      <p>
        {{vademecum.medicalDoc.hasPhysicalDisability}}
      </p>
      <p>
        {{vademecum.medicalDoc.hasSkinAffection}}
      </p>
      <p>
        {{vademecum.medicalDoc.hasSleepDisorder}}
      </p>
      <p>
        {{vademecum.medicalDoc.otherDiseases}}
      </p>
      <p>
        {{vademecum.medicalDoc.lastSkinTestDate}}
      </p>
      <p>
        {{vademecum.medicalDoc.positiveSkinTestDate}}
      </p>
      <p>
        {{vademecum.medicalDoc.hadTetanusVaccination}}
      </p>
      <p>
        {{vademecum.medicalDoc.tetanusBoosterYear}}
      </p>
      <p>
        {{vademecum.medicalDoc.hasAllergiesToMedicines}}
      </p>
      <p>
        {{vademecum.medicalDoc.allergiesCauseMedicine}}
      </p>
      <p>
        {{vademecum.medicalDoc.hasAllergiesToSubstances}}
      </p>
      <p>
        {{vademecum.medicalDoc.allergiesCauseSubstance}}
      </p>
      <p>
        {{vademecum.medicalDoc.isIncontinent}}
      </p>
      <p>
        {{vademecum.medicalDoc.isQuicklyTired}}
      </p>
      <p>
        {{vademecum.medicalDoc.isSensitiveToChilling}}
      </p>
      <p>
        {{vademecum.medicalDoc.canSportWithoutRisk}}
      </p>
      <p>
        {{vademecum.medicalDoc.needMedicalTreatment}}
      </p>
      <p>
        {{vademecum.medicalDoc.bloodType.name}}
      </p>
      <p>
        {{vademecum.medicalDoc.otherInformations}}
      </p>
      <p>
        {{vademecum.medicalDoc.emergencyContactAddress}}
      </p>
      <p>
        {{vademecum.medicalDoc.emergencyPhoneNumber}}
      </p>
      <p>
        {{vademecum.medicalDoc.emergencyEveningPhoneNumber}}
      </p>
      <p>
        {{vademecum.medicalDoc.hasMentalDisorder}}
      </p>
      <p>
        {{vademecum.medicalDoc.mentalDisorderDescription}}
      </p>
    </div> -->
    <div class="page">
      <!-- <div>
        <p>{{vademecum.schoolDoc.firstName}}</p>
        <p>{{vademecum.schoolDoc.lastName}}</p>
        <p>{{vademecum.schoolDoc.studyDutchInSchool}}</p>
        <p>{{vademecum.schoolDoc.studyEnglishInSchool}}</p>
        <p>{{vademecum.schoolDoc.studyFrenchInSchool}}</p>
        <p>{{vademecum.schoolDoc.dutchStudyYears}}</p>
        <p>{{vademecum.schoolDoc.englishStudyYears}}</p>
        <p>{{vademecum.schoolDoc.frenchStudyYears}}</p>
        <p>{{vademecum.schoolDoc.frequencySpeakingWithFamily.name}}</p>
        <p>{{vademecum.schoolDoc.frequencySpeakingWithFriends.name}}</p>
        <p>{{vademecum.schoolDoc.hasLearningDifficulty}}</p>
        <p>{{vademecum.schoolDoc.hadLanguageTest}}</p>
        <p>{{vademecum.schoolDoc.languageTestDate}}</p>
        <p>{{vademecum.schoolDoc.matterToReview}}</p>
        <p>{{vademecum.schoolDoc.studyBookName}}</p>
        <p>{{vademecum.schoolDoc.dutchTeacherName}}</p>
        <p>{{vademecum.schoolDoc.englishTeacherName}}</p>
        <p>{{vademecum.schoolDoc.frenchTeacherName}}</p>
        <p>{{vademecum.schoolDoc.isComingWithFriends}}</p>
        <p>{{vademecum.schoolDoc.friendName}}</p>
      </div> -->
    </div>
  </div>
</div>